import { FC, ReactNode } from "react";

interface IProps {
  isLoading: boolean;
  fullWidth?: boolean;
  children: ReactNode;
}
export const Loader: FC<IProps> = ({ isLoading, fullWidth, children }) => (
  <div className={`loader-container ${fullWidth ? "full-width" : "width-fit"}`}>
    <div className={isLoading ? "loading-content loading" : "loading-content"}>
      {children}
    </div>
    {isLoading && (
      <div className="loader">
        <span className="spinner" />
      </div>
    )}
  </div>
);

export const FullScreenLoader: FC<{ isLoading: boolean }> = ({ isLoading }) =>
  isLoading ? (
    <div className="full-screen-loader">
      <div className="loader">
        <span className="spinner" />
      </div>
    </div>
  ) : null;
